import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const ProfileIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 15C14.0711 15 15.75 13.3211 15.75 11.25C15.75 9.17893 14.0711 7.5 12 7.5C9.92893 7.5 8.25 9.17893 8.25 11.25C8.25 13.3211 9.92893 15 12 15Z" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.98145 18.6938C6.54574 17.5824 7.40678 16.6488 8.46914 15.9968C9.5315 15.3447 10.7537 14.9995 12.0002 14.9995C13.2467 14.9995 14.4689 15.3447 15.5313 15.9968C16.5936 16.6488 17.4547 17.5824 18.0189 18.6938" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(ProfileIcon);
